import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';

const NotFound = () => {
  const navigate = useNavigate();
  const [counter, setCounter] = useState(10);
  const [dogPosition, setDogPosition] = useState(0);

  useEffect(() => {
    // 倒计时重定向
    if (counter > 0) {
      const timer = setTimeout(() => setCounter(counter - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      navigate('/');
    }
  }, [counter, navigate]);

  useEffect(() => {
    // 小狗跑步动画
    const interval = setInterval(() => {
      setDogPosition(prev => (prev + 10) % 100);
    }, 100);
    
    return () => clearInterval(interval);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const searchTerm = e.target.search.value;
    if (searchTerm.trim()) {
      navigate(`/?search=${encodeURIComponent(searchTerm)}`);
    }
  };

  const quickLinks = [
    { path: '/', label: '回到首页', icon: '🏠', desc: '返回温暖的小窝' },
    { path: '/write', label: '写文章', icon: '✏️', desc: '开始新的创作' },
    { path: '/archive', label: '浏览文章', icon: '📚', desc: '发现精彩内容' },
    { path: '/about', label: '关于我们', icon: '🐶', desc: '了解博客故事' },
  ];

  return (
    <div className="not-found-page fade-in">
      <div className="not-found-container">
        {/* 顶部小狗动画 */}
        <div className="running-dog">
          <div 
            className="dog-container"
            style={{ transform: `translateX(${dogPosition}%)` }}
          >
            <span className="dog">🐕</span>
            <span className="dog-bone">🦴</span>
          </div>
          <div className="paw-trail">
            {[...Array(10)].map((_, i) => (
              <span key={i} className="paw">🐾</span>
            ))}
          </div>
        </div>

        {/* 主要错误信息 */}
        <div className="error-content">
          <div className="error-number">
            <span className="digit">4</span>
            <span className="dog-digit">🐕</span>
            <span className="digit">4</span>
          </div>
          
          <h1 className="error-title">哎呀，页面走丢了！</h1>
          <p className="error-description">
            小狗们正在努力寻找这个页面，但是好像跑到了其他地方玩耍。
            <br />
            {counter}秒后自动跳转回首页，或者你可以：
          </p>

          {/* 搜索框 */}
          <div className="search-section">
            <form onSubmit={handleSearch} className="error-search">
              <input
                type="text"
                name="search"
                placeholder="试试搜索你想找的内容..."
                className="search-input"
                autoFocus
              />
              <button type="submit" className="search-btn">
                <span className="search-icon">🔍</span>
                搜索
              </button>
            </form>
          </div>

          {/* 快速链接 */}
          <div className="quick-links">
            <h3>🐾 快速导航</h3>
            <div className="links-grid">
              {quickLinks.map((link, index) => (
                <Link key={index} to={link.path} className="quick-link">
                  <span className="link-icon">{link.icon}</span>
                  <div className="link-content">
                    <span className="link-label">{link.label}</span>
                    <span className="link-desc">{link.desc}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>

          {/* 返回按钮 */}
          <div className="action-buttons">
            <button 
              className="btn btn-primary back-home-btn"
              onClick={() => navigate('/')}
            >
              <span className="btn-icon">🏠</span>
              立即回到首页
            </button>
            <button 
              className="btn btn-secondary refresh-btn"
              onClick={() => window.location.reload()}
            >
              <span className="btn-icon">🔄</span>
              刷新页面
            </button>
          </div>

          {/* 帮助信息 */}
          <div className="help-section">
            <h4>需要帮助？</h4>
            <div className="help-options">
              <a href="mailto:support@puppylog.com" className="help-option">
                <span className="help-icon">📧</span>
                联系客服
              </a>
              <a href="/faq" className="help-option">
                <span className="help-icon">❓</span>
                查看常见问题
              </a>
              <a href="/sitemap" className="help-option">
                <span className="help-icon">🗺️</span>
                浏览网站地图
              </a>
            </div>
          </div>
        </div>

        {/* 底部装饰 */}
        <div className="error-decoration">
          <div className="decoration-message">
            <span className="message-icon">💭</span>
            <p>"别担心，小狗会帮你找到回家的路！"</p>
          </div>
          <div className="bouncing-bones">
            <span className="bone">🦴</span>
            <span className="bone">🦴</span>
            <span className="bone">🦴</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;